import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { DependencyFilterKeys } from '../../../../../shared/dependenciesV2';
import { BINARY_DECOMPOSITION } from '../../../../../shared/featureFlags/flagNames';
import * as DependenciesV2Store from '../../../../redux/dependenciesV2';
import FilterPanel from '../../../generic/Filter/FilterPanel';
import FeatureFlagRequired from '../../../generic/Gates/FeatureFlagRequired';
import FossabotAlphaAd from '../../../shared/ads/fossabotAlphaAd';

import DependencyConfidenceFilter from './PackageFilters/DependencyConfidenceFilter';
import DepthFilter from './PackageFilters/DepthFilter';
import HasIssuesFilter from './PackageFilters/IssueFilter';
import LayerFilter from './PackageFilters/LayerFilter';
import LicenseFilter from './PackageFilters/LicenseFilter';
import PackageLabelsFilter from './PackageFilters/PackageLabelsFilter';
import PackageManagerFilter from './PackageFilters/PackageManagerFilter';
import RootProjectsFilter from './PackageFilters/RootProjectsFilter';
import StatusFilter from './PackageFilters/StatusFilters';

import styles from './Filters.module.less';

type Props = {
  shouldDisplayConfidenceFilter: boolean;
  isContainerProject: boolean;
  isReleaseGroupScope: boolean;
  isVendoredView?: boolean;
};

const DependencyFilters: VoidFunctionComponent<Props> = ({
  shouldDisplayConfidenceFilter,
  isContainerProject,
  isReleaseGroupScope,
  isVendoredView = false,
}) => {
  const stateFilters = useSelector(DependenciesV2Store.selectors.getFilters);
  const isOrgMember = useSelector(DependenciesV2Store.selectors.getIsOrgMember);
  return (
    <>
      <FilterPanel title="Package">
        <div className={styles.PackageFilters}>
          {isReleaseGroupScope && <RootProjectsFilter />}
          <StatusFilter />
          {!isVendoredView && <DepthFilter />}
          { shouldDisplayConfidenceFilter &&
            <FeatureFlagRequired flagName={BINARY_DECOMPOSITION}>
              <DependencyConfidenceFilter />
            </FeatureFlagRequired>}
          {isContainerProject && <LayerFilter />}
          <PackageManagerFilter />
          <PackageLabelsFilter />
          {isOrgMember && (
            <HasIssuesFilter selectedOptions={stateFilters[DependencyFilterKeys.HasIssues]} />
          )}
          <LicenseFilter />
        </div>
      </FilterPanel>
      <FossabotAlphaAd />
    </>
  );
};

export default DependencyFilters;
